import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { DashboardStats } from '@/services/dashboardApi'
import { DashboardCard } from './DashboardCard'

export interface TeamsPanelProps {
  teams: DashboardStats['teams']
}

/** Equipos del negocio en una fila compacta; la gestión vive en Organización. */
export function TeamsPanel({ teams }: TeamsPanelProps) {
  if (teams.length === 0) return null

  return (
    <DashboardCard
      title="Equipos"
      titleId="teams-title"
      state="success"
      action={
        <Link
          to="/app/organization"
          className="flex items-center gap-1 text-xs font-medium text-brand hover:text-brand-dark"
        >
          Gestionar equipos
          <ArrowRight className="h-3 w-3" aria-hidden="true" />
        </Link>
      }
    >
      <ul className="divide-y divide-slate-100">
        {teams.map((team) => (
          <li key={team.id} className="flex flex-wrap items-center justify-between gap-2 px-4 py-3">
            <p className="text-sm font-semibold text-slate-900">{team.name}</p>
            <p className="text-xs text-slate-500">
              {team.membersCount} {team.membersCount === 1 ? 'miembro' : 'miembros'} ·{' '}
              {team.conversationsCount} {team.conversationsCount === 1 ? 'conversación' : 'conversaciones'}
            </p>
          </li>
        ))}
      </ul>
    </DashboardCard>
  )
}
